import { useQuery } from '@tanstack/react-query';
import { requestCCApi } from 'src/utils/axios-utils';
import { queryKeys } from 'src/utils/queryKeys';

import { mapAllLayoutTypes } from './helpers';

export const useGetAllLayoutType = () =>
  useQuery({
    queryKey: queryKeys.layoutTypes.all(),
    queryFn: fetchLayoutType,
    staleTime: Infinity,
  });

export const fetchLayoutType = async () => {
  const response = await requestCCApi({
    url: `/layoutTypes?pageSize=0`,
  });

  return mapAllLayoutTypes(response.data);
};
